<div class="error-container">
  <growth-report-cel-error-message
    [errorMessage]="'messages.error' | translate"
    [directions]="'messages.sub-error' | translate"
  ></growth-report-cel-error-message>
</div>
